var checkLang = $('html').attr('lang');
var langFE = {}
langFE['vi'] = {
	"buy": "Mua",
	"sell": "Bán",
	"buying": "Mua vào",
	"selling": "Bán ra",
	"change": "Thay đổi",
	"unit": "VNĐ",
	"date": "Ngày cập nhật",
	"price": "Giá",
	"apply": "Áp dụng",
	"cancel": "Huỷ",
	"custom": "Tùy chỉnh",
	"yesterday": "Hôm qua",
	"today": "Hôm nay",
	"last7Days": "7 ngày gần đây",
	"last30Days": "30 ngày gần đây",
	"thisMonth": "Tháng này",
	"lastMonth": "Tháng trước",
}
langFE['en'] = {
	"buy": "Buy",
	"sell": "Sell",
	"buying": "Buying",
	"selling": "Selling",
	"change": "Change",
	"unit": "VND",
	"date": "Update date",
	"price": "Price",
	"apply": "Apply",
	"cancel": "Cancel",
	"custom": "Custom",
	"yesterday": "Yesterday",
	"today": "Today",
	"last7Days": "Last 7 days",
	"last30Days": "Last 30 days",
	"thisMonth": "This month",
	"lastMonth": "Last month",
}

$(function () {
	APP.init();

	lozadInit();
	fancyboxInit();
	setBackground();

	filterInit();
	accordionInit();
	countUpInit();
	loadMoreInit();

	toggleNavSticky();
	toggleSiteMaps();
	moveHTML();
	$('.full-content table').each(function () {
		$(this).wrap('<div class="table-responsive"></div>')
	});

	$('.select-list li a').on('click', function(){
		let selectText = $(this).text();
		$(this).addClass('active').parent().siblings().find('a').removeClass('active');
		$(this).parents('.select-dropdown').find('.select-current').text(selectText);
	});

	printPage();
	dealerInit();
	setHeightElm();
});

$(window).on('scroll', function () {
	APP.fixed();
});

// variable
var header = $("header"),
	backdrop = $(".backdrop"),
	backToTop = $(".back-to-top"),
	heightHeader = $("header").height(),
	heightWindow = $(window).height(),
	widthWindow = $(window).width(),
	outerHeightWindow = $(window).outerHeight();

// toggleText
$.fn.extend({
	toggleText: function (a, b) {
		return this.text(this.text() == b ? a : b);
	},
});

var APP = {
	fixed: () => {
		// header
		$(window).scrollTop() > heightHeader
			? header.addClass("active")
			: header.removeClass("active");
		$(window).scrollTop() > (outerHeightWindow - heightHeader)
			? backToTop.addClass("active")
			: backToTop.removeClass("active");
	},
	backdrop: () => {
		backdrop.on('click', function () {
			$(this).removeClass('show');
			header.removeClass("open"); // remove header
			$("#buttonMenu").removeClass('open'); // remove button menu header
			$("header .menu-wrap").removeClass('open'); // remove menu header
		})
	},
	backToTop: () => {
		backToTop.on('click', function () {
			$('html, body').animate({ scrollTop: 0 }, 500);
		})
	},
	mapping: () => {
		const mainMenuLeft = $("header .header-left .navbar-menu").mapping({
			mobileWrapper: "header .mobile-wrap .navbar-wrap",
			mobileMethod: "appendTo",
			desktopWrapper: "header .header-left",
			desktopMethod: "appendTo",
			breakpoint: 1279.98,
		});
		const mainMenuRight = $("header .header-right .navbar-menu").mapping({
			mobileWrapper: "header .mobile-wrap .navbar-wrap",
			mobileMethod: "appendTo",
			desktopWrapper: "header .header-right",
			desktopMethod: "appendTo",
			breakpoint: 1279.98,
		});
		let hotline = $("header .button-hotline").mapping({
			mobileWrapper: "main",
			mobileMethod: "appendTo",
			desktopWrapper: "header .header-left .navbar-menu",
			desktopMethod: "insertBefore",
			breakpoint: 1279.98,
		});
	},
	toggleMenu: () => {
		$("#buttonMenu").on("click", function () {
			$(this).toggleClass("open");
			$('.mobile-wrap').toggleClass("open");
		});

		$(".main-menu .has-mega-menu .mega-icon").on("click", function () {
			$(this).toggleClass("active").next().slideToggle().parent().siblings().find('.mega-icon').removeClass('active').next().slideUp();
		});

		$(".main-menu .has-dropdown-menu .dropdown-icon").on("click", function () {
			$(this).toggleClass("active").next().slideToggle().parent().siblings().find('.mega-icon').removeClass('active').next().slideUp();
		});
	},
	toggleSearch: () => {
		$('.button-search').on("click", function () {
			$(this).toggleClass("active");
			$('.searchbox').toggleClass("active");
		});
	},
	sourceInfo: () => {
		console.log(
			"%cSJC",
			"font-size:100px;color:#D0A448;text-shadow:0 1px 0 #005387,0 2px 0 #005387 ,0 3px 0 #005387 ,0 4px 0 #005387 ,0 5px 0 #005387 ,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15);"
		);
		console.log(
			"%c SJC %c - SJC in Viet Nam",
			"border-radius: 2px; padding: 3px; background: #D0A448; color: #000",
			"color: #D0A448"
		);
	},
	init: () => {
		APP.backdrop();
		APP.backToTop();
		APP.mapping();
		APP.toggleMenu();
		APP.toggleSearch();
		APP.sourceInfo();
	}
}

const homeBannerSlider = new Swiper(".home-banner .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 1000,
	// rewind: true,
	pagination: {
		el: ".home-banner .swiper-pagination",
		type: 'bullets',
		clickable: true,
	},
	on: {
		init: function () {
			if ($('.home-banner video').length>0){
				this.autoplay.stop()
				var index = this.activeIndex;
				checkSlide($(this.slides[index]), this)
			}
		},
		slideChange: function () {
			if ($('.home-banner video').length > 0) {
				this.autoplay.stop()
				var index = this.activeIndex;
				checkSlide($(this.slides[index]), this)
			}
		},
	},
});

function checkSlide(type, slider){
	var currentSlide = type;
	var currentSlideType = currentSlide.data('slide-type');
	slider.autoplay.stop()
	switch (currentSlideType) {
		case 'image':
			slider.autoplay.start()
			break;
		case 'video':
			var video = currentSlide.find('video')[0];
			video.play()
			video.addEventListener("canplay", function () {
				// console.log("canplay");
			}, true);
			video.addEventListener("ended", function () {
				// console.log("ended");
				slider.slideNext();
				slider.autoplay.start()
			}, true);
			break;
		default:
			throw new Error('invalid slide type');
	}
	return
}

const homeCategoriesSlider = new Swiper(".home-categories .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 1000,
	slidesPerView: 2,
	spaceBetween: 10,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-categories .button-next",
		prevEl: ".home-categories .button-prev",
	},
	pagination: {
		el: ".home-categories .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 3,
			spaceBetween: 15,
		},
		768: {
			slidesPerView: 4,
			spaceBetween: 15,
		},
		1024: {
			slidesPerView: 5,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 6,
			spaceBetween: 30,
		},
	},
});

const homeProductsSlider = new Swiper(".home-products .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 1000,
	spaceBetween: 10,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-products .button-next",
		prevEl: ".home-products .button-prev",
	},
	pagination: {
		el: ".home-products .swiper-pagination",
		clickable: true,
	},
	// scrollbar: {
	// 	el: ".home-products .swiper-scrollbar",
	// 	// hide: true,
	// 	draggable: true,
	// },
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 10,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 15,
		},
		1024: {
			slidesPerView: 4,
			spaceBetween: 15,
		},
		1280: {
			slidesPerView: 4,
			spaceBetween: 20,
		},
	},
});

const homeNewsSlider = new Swiper(".home-news .swiper", {
	speed: 1000,
	spaceBetween: 15,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-news .button-next",
		prevEl: ".home-news .button-prev",
	},
	pagination: {
		el: ".home-news .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
		1440: {
			slidesPerView: 3,
			spaceBetween: 50,
		},
		1600: {
			slidesPerView: 3,
			spaceBetween: 75,
		},
	},
});

const homeAboutSlider = new Swiper(".home-abouts .swiper", {
	speed: 1000,
	spaceBetween: 15,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-abouts .button-next",
		prevEl: ".home-abouts .button-prev",
	},
	pagination: {
		el: ".home-abouts .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 31,
		},
	},
});

const homeSupportSlider = new Swiper(".home-supports .swiper", {
	speed: 1000,
	spaceBetween: 15,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-supports .button-next",
		prevEl: ".home-supports .button-prev",
	},
	pagination: {
		el: ".home-supports .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 4,
			spaceBetween: 30,
		},
	},
});

const historyThumbsSlider = new Swiper(".about-3 .swiper-thumbs", {
	// loop: true,
	slidesPerView: 3,
	centeredSlides: true,
	slideToClickedSlide: true,
	breakpoints: {
		576: {
			slidesPerView: 4,
		},
		768: {
			slidesPerView: 5,
		},
		1024: {
			slidesPerView: 6,
		},
		1280: {
			slidesPerView: 7,
			initialSlide: 3,
		},
	},
	navigation: {
		nextEl: ".about-3 .button-next",
		prevEl: ".about-3 .button-prev",
	},
});

const historyTopSlider = new Swiper(".about-3 .swiper-top", {
	// loop: true,
	spaceBetween: 30,
	centeredSlides: true,
	loopedSlides: 3,
	allowTouchMove: false,
	breakpoints: {
		576: {
			loopedSlides: 4,
		},
		768: {
			loopedSlides: 5,
		},
		1024: {
			loopedSlides: 6,
		},
		1280: {
			loopedSlides: 7,
			initialSlide: 3,
		},
	},
});

const historyControlSlider = new Swiper(".about-3 .swiper-control", {
	// loop: true,
	spaceBetween: 30,
	centeredSlides: true,
	loopedSlides: 3,
	allowTouchMove: false,
	breakpoints: {
		576: {
			loopedSlides: 4,
		},
		768: {
			loopedSlides: 5,
		},
		1024: {
			loopedSlides: 6,
		},
		1280: {
			loopedSlides: 7,
			initialSlide: 3,
		},
	},
});

historyThumbsSlider.controller.control = historyTopSlider;
historyThumbsSlider.controller.control = historyControlSlider;
historyControlSlider.controller.control = historyTopSlider;

const aaThumbsSlider = new Swiper(".about-4 .swiper-thumbs", {
	// loop: true,
	slidesPerView: 3,
	centeredSlides: true,
	slideToClickedSlide: true,
	breakpoints: {
		768: {
			direction: "vertical",
		},
		1024: {
			direction: "vertical",

		},
		1280: {
			direction: "vertical",
		},
	},

});

const aaTopSlider = new Swiper(".about-4 .swiper-top", {
	// loop: true,
	spaceBetween: 30,
	allowTouchMove: false,
	breakpoints: {
		768: {
			direction: "vertical",
			spaceBetween: 30,
		},
		1024: {
			direction: "vertical",
			spaceBetween: 30,
		},
		1280: {
			direction: "vertical",
			spaceBetween: 30,
		},
	},
});

$('.about-4 .swiper-aa').each(function (index) {
	$(this).addClass(`swiper-aa-${index}`);
	// $(this).find('.button-prev').addClass(`button-prev-${index}`);
	// $(this).find('.button-next').addClass(`button-next-${index}`);
	const aaControlSlider = new Swiper(`.about-4 .swiper-aa-${index} .swiper`, {
		// loop: true,
		spaceBetween: 30,
		slidesPerView: 2,
		breakpoints: {
			576: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 4,
				spaceBetween: 55,
			},
		},
		navigation: {
			nextEl: `.about-4 .swiper-aa-${index} .button-next`,
			prevEl: `.about-4 .swiper-aa-${index} .button-prev`,
		},
	});
})

aaThumbsSlider.controller.control = aaTopSlider;
aaTopSlider.controller.control = aaThumbsSlider;

const productListSlider = new Swiper(".product-list-section .swiper", {
	speed: 1000,
	slidesPerView: 1,
	spaceBetween: 15,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".product-list-section .button-next",
		prevEl: ".product-list-section .button-prev",
	},
	pagination: {
		el: ".product-list-section .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2
		},
		768: {
			slidesPerView: 2
		},
		1024: {
			slidesPerView: 3
		},
		1280: {
			slidesPerView: 3
		},
	},
});

const productDetailThumbsSlider = new Swiper(".product-detail-slider .swiper-thumbs", {
	loop: true,
	slidesPerView: 4,
	spaceBetween: 10,
	slideToClickedSlide: true,
	rewind: true,
	breakpoints: {
		768: {
			slidesPerView: 4,
			spaceBetween: 10,
		},
		1024: {
			slidesPerView: 5,
			spaceBetween: 15,
		},
		1280: {
			slidesPerView: 5,
			spaceBetween: 20,
		},
	},
});

const productDetailTopSlider = new Swiper(".product-detail-slider .swiper-top", {
	// rewind: true,
	loop: true,
	spaceBetween: 30,
	thumbs: {
		swiper: productDetailThumbsSlider,
	},
	navigation: {
		nextEl: ".product-detail-slider .button-next",
		prevEl: ".product-detail-slider .button-prev",
	},
	// on: {
	// 	slideChange: function () {
	// 		let activeIndex = this.activeIndex + 1;
	// 		let activeSlide = document.querySelector(`.product-detail-slider .swiper-top .swiper-slide:nth-child(${activeIndex})`);
	// 		let nextSlide = document.querySelector(`.product-detail-slider .swiper-top .swiper-slide:nth-child(${activeIndex + 1})`);
	// 		let prevSlide = document.querySelector(`.product-detail-slider .swiper-top .swiper-slide:nth-child(${activeIndex - 1})`);
	// 		if (nextSlide && !nextSlide.classList.contains('swiper-slide-visible')) {
	// 			this.thumbs.swiper.slideNext()
	// 		} else if (prevSlide && !prevSlide.classList.contains('swiper-slide-visible')) {
	// 			this.thumbs.swiper.slidePrev()
	// 		}
	// 	}
	// }
});

const productDetailRelatedSlider = new Swiper(`.product-related .swiper`, {
	speed: 1000,
	spaceBetween: 10,
	slidesPerView: 2,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	scrollbar: {
		el: `.product-related .swiper-scrollbar`,
		draggable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 4,
			spaceBetween: 20,
		},
	},
});

const productDetailViewedSlider = new Swiper(`.product-viewed .swiper`, {
	speed: 1000,
	spaceBetween: 10,
	slidesPerView: 2,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	scrollbar: {
		el: `.product-viewed .swiper-scrollbar`,
		draggable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 4,
			spaceBetween: 20,
		},
	},
});

const productDetailNewsSlider = new Swiper(`.product-detail .news-related .swiper`, {
	speed: 1000,
	spaceBetween: 20,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	scrollbar: {
		el: `.product-detail .news-related .swiper-scrollbar`,
		draggable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
	},
});

const brandSlider = new Swiper(".brand-section .swiper", {
	slidesPerView: 2,
	grid: {
		rows: 2,
	},
	spaceBetween: 10,
	navigation: {
		nextEl: ".brand-section .button-next",
		prevEl: ".brand-section .button-prev",
	},
	pagination: {
		el: ".brand-section .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 3,
		},
		768: {
			slidesPerView: 4,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 5,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 6,
			spaceBetween: 30,
		},
	},
});

const recruitmentListSlider = new Swiper(".recruitment-list-section .swiper", {
	spaceBetween: 10,
	pagination: {
		el: ".recruitment-list-section .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
	},
});

function lozadInit() {
	// Initialize library to lazy load images
	const observer = lozad('.lozad', {
		threshold: 0.1,
		// enableAutoReload: true,
	})

	// Picture observer
	// with default `load` method
	const pictureObserver = lozad('.lozad-picture', {
		threshold: 0.1
	})

	// Background observer
	// with default `load` method
	const backgroundObserver = lozad('.lozad-background', {
		threshold: 0.1
	})

	observer.observe()
	pictureObserver.observe()
	backgroundObserver.observe()
}

function fancyboxInit() {
	Fancybox.bind("[data-fancybox]", {
		showLoading: true,
		preload: true,
		infinite: false,
		// parentEl: document.forms[0], // Element containing main structure
		mainClass: "fancybox-wrapper", // Custom class name or multiple space-separated class names for the container
	});

	Fancybox.bind("a.popup-link", {
		showLoading: true,
		type: "iframe",
		preload: true,
	});

	Fancybox.bind('[data-fancybox="single"]', {
		groupAttr: false,
	});

	$(".btn-close-fancybox").on("click", function () {
		Fancybox.close();
	});
}

function setBackground() {
	$('[data-background]').each(function () {
		$(this).css('background-image', 'url(' + $(this).data('background') + ')');
	});
}

function equalHeight(el) {
	var height = 0;
	$(el).each(function () {
		var thisHeight = $(this).height();
		if (thisHeight > height) {
			height = thisHeight;
		}
		setTimeout(() => {
			$(el).height(height)
		}, 100)
	})
}

function checkCookie(cookieName) {
	let mP = getCookie(cookieName);
	$('.home-product .product-item a').on('click', function () {
		var dataMPC = $(this).data('master-plan');
		setCookie("masterPlan", dataMPC, 1);
	});
	if (mP != "") {
		$('.master-plan .main-tabslet').tabslet({
			active: Number(mP)
		});
		setTimeout(() => {
			$(`.site-plan .site-plan-tabs .plan-list li a[data-maphilight="maparea-${mP}"]`).trigger('click');
		}, 500);
	} else {
		$('.master-plan .main-tabslet').tabslet();
	}
}

function countStart(el, num) {
	const options = {
		separator: '.',
		enableScrollSpy: true, // if true -> turn off countUp.start() after first scroll spy check
		scrollSpyDelay: 500, // delay for scroll spy check
		scrollSpyOnce: true,
	};

	let countUp = new CountUp(el, num, options);

	if (!countUp.error) {
		countUp.start(() => console.log('Complete!'));
	} else {
		console.error(countUp.error);
	}
}

function countUpInit() {
	const elNumber = $(".count-number-current");
	if (elNumber)
		elNumber.each(function (index) {
			let dataCount = $(elNumber[index]).data('count');
			countStart(elNumber[index], dataCount);
		})
}

function loadMoreInit() {
	$('.load-more-wrap').each(function () {
		var button = $(this).find('.btn-load-more');
		var contentItem = $(this).find('.load-more-item');
		var contentItemLength = contentItem.length;
		var contentItemShow = $(this).data('show');
		var contentItemLoad = $(this).data('load');
		contentItem.slice(contentItemShow, contentItemLength).addClass('hidden');
		button.on('click', function (e) {
			e.preventDefault();
			var $thisLoadMore = $(this).parents('.load-more-wrap');
			var visibleItem = $thisLoadMore.find('.load-more-item:visible').length;
			var hiddenItem = $thisLoadMore.find('.load-more-item:hidden').length;
			contentItem.slice(0, (visibleItem + contentItemLoad)).slideDown();
			if (hiddenItem <= contentItemLoad) {
				$(this).hide();
			}
		})
	});
}

function accordionInit() {
	$('.accordion_item').on('click', function () {
		$(this)
			.toggleClass('active')
			.siblings().removeClass('active')
		$(this)
			.find('.accordion_header').toggleClass('active')
			.parents('.accordion_item')
			.siblings().find('.accordion_header').removeClass('active')
		$(this)
			.find('.accordion_content').slideToggle()
			.parents('.accordion_item')
			.siblings().find('.accordion_content').slideUp('active')
	});
}

function filterInit() {
	$('.filter-button').on('click', function () {
		$('.filter-wrap').addClass('active');
	});
	$('.filter-dropdown').each(function () {
		$(this).find('.filter-current').on('click', function () {
			$(this).next().slideToggle();
			$(this).parent().siblings().find('.filter-list').slideUp();
			$(this).parent().parent().siblings().find('.filter-list').slideUp();
			$(this).parent().parent().parent().siblings().find('.filter-list').slideUp();
		})
		$('.filter-wrap').on('mouseleave', function () {
			setTimeout(() => {
				$('.filter-wrap').find('.filter-list').slideUp();
			}, 100);
		});
	});
	$('.filter-list > li > a').on('click', function (e) {
		e.preventDefault();
		let activeText = $(this).text();
		$(this).parents('.filter-dropdown').find('.filter-current').text(activeText);
		$(this).addClass('active').parent().siblings().find('a').removeClass('active');
	});
	$('.filter-close').on('click', function (e) {
		e.preventDefault();
		$('.filter-wrap').removeClass('active');
	});
}

function toggleNavSticky() {
	$('.box-nav-sticky .secondary-title').on('click', function () {
		if (widthWindow < 768)
			$(this).next().slideToggle()
		else
			return
	});
}

function moveHTML() {
	$('.product-filter-sort').appendTo('.filter-wrap .filter-right');
	$('.product-categories').prependTo('.filter-wrap .filter-left');
	$('.sjc-gold-tradingview').insertBefore('.sjc-international .sjc-price-global');
	$('.sjc-gold-tradingview').appendTo('.gold-price-flex .sjc-international span.text-primary');
	$('.sjc-gold-tradingview').appendTo('.chart-gold-global-wrap .chart-gold-global');
}

function printPage() {
	$('.btn-print').on('click', function () {
		window.print();
	});
}

function dealerInit() {
	$('.result-list ul li').on('click', function () {
		$(this).addClass('active').siblings().removeClass('active');
		var dataIframe = $(this).attr('data-iframe');
		$('.maps iframe').attr('src', dataIframe);
	});

	$('.result-list ul li:first-child').trigger('click');
}

function toggleSiteMaps() {
	$('.AspNet-TreeView-Collapse').on('click', function (e) {
		e.preventDefault();
	});
}

function setHeightElm(){
	setTimeout(()=>{
		var hPriceToday = $('.box-sjc-price.sjc-gold-price-chart').outerHeight();
		var hInternational = $('.box-sjc-price.sjc-international.is-sjc-new').outerHeight();
		$('.box-sjc-price.sjc-gold-price.is-sjc-new').css('max-height', hPriceToday)
		if(widthWindow>768)
			$('.box-sjc-price.exchange-rate.is-sjc-new').css('height', (hPriceToday - hInternational - 20))
	},1000)
}

// $(function () {
// 	CallAPIGoldPrice(); // Giá vàng SJC
// 	CallAPIInternationalGoldPrice(); // Giá vàng thế giới
// 	CallAPIGoldPriceToday(); // Giá vàng hôm nay
// });

// var siteRootFE = 'http://www8.sjc.com.vn';

// function CallAPIGoldPrice(){
// 	var dataAPI;
// 	var latestDate;
// 	var APIUrl = `${siteRootFE}/GoldPrice/Services/PriceService.ashx`;
// 	var configs = {
// 		"url": APIUrl,
// 		"method": "POST",
// 		"timeout": 0,
// 	};
// 	var checkGoldPrice = $('.sjc-gold-price');
// 	var checkGoldPriceChart = $('.sjc-gold-price-chart');
// 	var checkGoldPriceOnline = $('.sjc-table-show-price-online');
// 	if(checkGoldPriceChart.length > 0){
// 		// render chart
// 		var ctx = document.getElementById('gold-price-chart');
// 		var myChart = new Chart(ctx, {
// 			type: 'line',
// 			data: null,
// 			options: {
// 				scales: {
// 					x: {
// 						display: true,
// 						ticks: {
// 							callback: function (value, index, ticks) {
// 								if (index === 0 || index + 1 === ticks.length || index === Math.round(ticks.length / 2)) {
// 									return this.getLabelForValue(value).substring(0, 10);
// 								}
// 								return null;
// 							}
// 						}
// 					}
// 				},
// 				interaction: {
// 					mode: 'index',
// 					intersect: false
// 				},
// 				responsive: true,
// 				plugins: {
// 					legend: {
// 						position: 'bottom'
// 					},
// 					// tooltip: {
// 					// 	callbacks: {
// 					// 		footer(tooltipItems) {
// 					// 			const [buy, sell] = tooltipItems;
// 					// 			return `Chênh lệch: ${Math.abs(buy.parsed.y - sell.parsed.y)}`;
// 					// 		}
// 					// 	}
// 					// }
// 				}
// 			}
// 		});
// 	}
// 	$.ajax(configs).done(function (response) {
// 		dataAPI = response.data;
// 		latestDate = response.latestDate;
// 		if(checkGoldPrice.length > 0){
// 			SJCTableGoldPrice(dataAPI, latestDate);
// 		}
// 		if(checkGoldPriceOnline.length > 0){
// 			SJCTableGoldPriceOnline(dataAPI, latestDate); // Bảng giá vàng online
// 		}
// 		if(checkGoldPriceChart.length > 0){
// 			SJCChartAPIInit(dataAPI, APIUrl, configs, myChart); // Tạo select tên vàng
// 		}
// 	}).fail(function (error) {
// 		console.log(error)
// 	});

// 	// Cập nhật dữ liệu sau 30s
// 	setInterval(function () {
// 		$.ajax(configs).done(function (response) {
// 			dataAPI = response.data;
// 			latestDate = response.latestDate;
// 			if(checkGoldPrice.length > 0){
// 				SJCTableGoldPrice(dataAPI, latestDate);
// 			}
// 			if(checkGoldPriceOnline.length > 0){
// 				SJCTableGoldPriceOnline(dataAPI, latestDate);
// 			}
// 		})
// 		if(checkGoldPriceChart.length > 0){
// 			CallSJCChartAPIRealTime(dataAPI, APIUrl, configs, myChart);
// 		}
// 	}, 30000);
// }

// function SJCTableGoldPrice(data, latestDate){
// 	var tableGoldPrice = $('.sjc-table-show-price tbody');
// 	var realTimeUpdateGoldPrice = $('.sjc-gold-price-real-time');
// 	var countData = data.length; // Tổng số dữ liệu
// 	tableGoldPrice.empty(); // Xóa dữ liệu cũ
// 	realTimeUpdateGoldPrice.empty(); // Xóa dữ liệu cũ
// 	realTimeUpdateGoldPrice.html(latestDate); // Thêm dữ liệu mới
// 	for (let i = 0; i < data.length; i++) {
// 		var provinceName = data[i].provinceName; // Tên tỉnh
// 		var goldTypeName = data[i].goldType; // Loại vàng
// 		var totalCountUpdate = data[i].updateTime.length; // Tổng số lần cập nhật
// 		var buyingFormat = data[i].updateTime[totalCountUpdate - 1].buyingFormat; // Giá mua vào
// 		var sellingFormat = data[i].updateTime[totalCountUpdate - 1].sellingFormat; // Giá mua vào
// 		// html
// 		var trProvince = `<tr><td colspan="3">${provinceName}</td></tr>`;
// 		var trProvinceGold = `<tr><td>${goldTypeName}</td><td>${buyingFormat}</td><td>${sellingFormat}</td></tr>`;

// 		// Check if the province coincides
// 		var provinceIDPrev = i > 0 ? data[i-1].provinceId : false;
// 		var checkProvinceID = provinceIDPrev ? data[i].provinceId == provinceIDPrev : false;
// 		if(checkProvinceID){
// 			tableGoldPrice.append(trProvinceGold);
// 		}else{
// 			tableGoldPrice.append(trProvince);
// 			tableGoldPrice.append(trProvinceGold);
// 		}
// 	}
// }

// function SJCTableGoldPriceOnline(data, latestDate){
// 	var tableGoldPriceOnline = $('.sjc-table-show-price-online tbody');
// 	var realTimeUpdateGoldPrice = $('.sjc-gold-price-real-time');
// 	var provinceTitle = $('.province-name');
// 	var dataShared = [];
// 	tableGoldPriceOnline.empty(); // Xóa dữ liệu cũ
// 	realTimeUpdateGoldPrice.empty(); // Xóa dữ liệu cũ
// 	realTimeUpdateGoldPrice.html(latestDate); // Thêm dữ liệu mới
// 	var urlID = window.location.href.split('?id=')[1];
// 	// get data shared == true
// 	for (let i = 0; i < data.length; i++) {
// 		if(data[i].shared){
// 			dataShared.push(data[i]);
// 		}
// 	}
// 	// get data shared == false
// 	for (let i = 0; i < data.length; i++) {
// 		var totalCountUpdate = data[i].updateTime.length; // Tổng số lần cập nhật
// 		var goldType = data[i].goldType;
// 		var buyingFormat = data[i].updateTime[totalCountUpdate-1].buyingFormat;
// 		var sellingFormat = data[i].updateTime[totalCountUpdate-1].sellingFormat;
// 		var trProvinceGoldOnline = `<tr><td>${goldType}</td><td>${buyingFormat}</td><td>${sellingFormat}</td></tr>`;
// 		if(urlID != undefined && urlID != null){
// 			if(data[i].provinceId == urlID && data[i].provinceId == 1 && data[i].shared == false){
// 				provinceTitle.text(data[i].provinceName);
// 				tableGoldPriceOnline.append(trProvinceGoldOnline);
// 			} else {
// 				if(data[i].provinceId == urlID && data[i].provinceId > 1 && data[i].shared == false){
// 					provinceTitle.text(data[i].provinceName);
// 					tableGoldPriceOnline.append(trProvinceGoldOnline);
// 				}
// 			}
// 		}
// 		else {
// 			if(data[i].provinceId == 1 && data[i].shared == false){
// 				provinceTitle.text(data[i].provinceName);
// 				tableGoldPriceOnline.append(trProvinceGoldOnline);
// 			}
// 		}
// 	}
// 	// get data shared == true
// 	for (let x = 0; x < dataShared.length; x++) {
// 		var totalCountUpdate = dataShared[x].updateTime.length; // Tổng số lần cập nhật
// 		var goldType = dataShared[x].goldType;
// 		var buyingFormat = dataShared[x].updateTime[totalCountUpdate-1].buyingFormat;
// 		var sellingFormat = dataShared[x].updateTime[totalCountUpdate-1].sellingFormat;
// 		tableGoldPriceOnline.append(`<tr><td>${goldType}</td><td>${buyingFormat}</td><td>${sellingFormat}</td></tr>`);
// 	}
// }

// function CallAPIInternationalGoldPrice(){
// 	var checkGoldPriceInternational = $('.sjc-international');
// 	if(checkGoldPriceInternational.length > 0){
// 		var APIUrl = `${siteRootFE}/GoldPrice/Services/PriceService.ashx?method=GetGlobalPrice`;
// 		var configs = {
// 			"url": APIUrl,
// 			"method": "POST",
// 			"timeout": 0,
// 		};
// 		$.ajax(configs).done(function (response) {
// 			$('#global-buy').text(response.globalBuy);
// 			$('#global-sell').text(response.globalSell);
// 		}).fail(function (error) {
// 			console.log(error)
// 		});
// 		setInterval(function () {
// 			$.ajax(configs).done(function (response) {
// 				$('#global-buy').text(response.globalBuy);
// 				$('#global-sell').text(response.globalSell);
// 			})
// 		}, 30000);
// 	}
// }

// function SJCChartAPIInit(data, urlAPI, configsAPI, myChart){
// 	// render report range
// 	var reportRange = $('#reportrange');
// 	if(reportRange.length > 0){
// 		// render date range
// 		var start = moment().subtract(0, 'days');
// 		var end = moment();
// 		const langYesterday = `${langFE[checkLang].yesterday}`;
// 		const langToday = `${langFE[checkLang].today}`;
// 		const lang7Days = `${langFE[checkLang].last7Days}`;
// 		const lang30Days = `${langFE[checkLang].last30Days}`;
// 		const langThisMonth = `${langFE[checkLang].thisMonth}`;
// 		const langLastMonth = `${langFE[checkLang].lastMonth}`;
// 		function cb(start, end) {
// 			$('#reportrange span').html(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));
// 		}
// 		var periodRanges = {};
// 		periodRanges[langToday] = [moment(), moment()];
// 		periodRanges[langYesterday] = [moment().subtract(1, 'days'), moment().subtract(0, 'days')];
// 		periodRanges[lang7Days] = [moment().subtract(6, 'days'), moment()];
// 		periodRanges[lang30Days] = [moment().subtract(29, 'days'), moment()];
// 		periodRanges[langThisMonth] = [moment().startOf('month'), moment().endOf('month')];
// 		periodRanges[langLastMonth] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
// 		// reportrange
// 		reportRange.daterangepicker({
// 			timePicker24Hour: true,
// 			startDate: start,
// 			endDate: end,
// 			ranges: periodRanges,
// 			// ranges: {
// 			// 	langToday: [moment(), moment()],
// 			// 	langYesterday: [moment().subtract(1, 'days'), moment().subtract(0, 'days')],
// 			// 	lang7Days: [moment().subtract(6, 'days'), moment()],
// 			// 	lang30Days: [moment().subtract(29, 'days'), moment()],
// 			// 	langThisMonth: [moment().startOf('month'), moment().endOf('month')],
// 			// 	langLastMonth: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
// 			// },
// 			locale: {
// 				'customRangeLabel': `${langFE[checkLang].custom}`,
// 				'format': 'DD/MM/YYYY HH:mm',
// 				'applyLabel': `${langFE[checkLang].apply}`,
// 				'cancelLabel': `${langFE[checkLang].cancel}`,
// 			}
// 		}, cb);
// 		cb(start, end);
// 	}
// 	// render select province
// 	var selectProvince = $('#select-province');
// 	selectProvince.empty();
// 	for (let i = 0; i < data.length; i++) {
// 		var fullName = data[i].fullName;
// 		var option = `<option value="${i}">${fullName}</option>`;
// 		selectProvince.append(option);
// 	}

// 	// call api
// 	CallSJCChartAPI(0, configsAPI, myChart); // Tạo biểu đồ

// 	// change province
// 	selectProvince.on('change', function () {
// 		var valueSelect = $(this).val();
// 		var dateStart = $('#reportrange').data('daterangepicker').startDate.format('YYYY-MM-DD');
// 		var dateEnd = $('#reportrange').data('daterangepicker').endDate.format('YYYY-MM-DD');
// 		var queryParamsAPI = `?fromdate=${dateStart}&todate=${dateEnd}`;
// 		var newConfigsAPI = configsAPI;
// 		newConfigsAPI.url = dateStart == dateEnd ? `${urlAPI}` : `${urlAPI}${queryParamsAPI}`;
// 		CallSJCChartAPI(valueSelect, newConfigsAPI, myChart);
// 	});

// 	// change date range
// 	reportRange.on('apply.daterangepicker', function (ev, picker) {
// 		var valueSelect = selectProvince.val();
// 		var dateStart = picker.startDate.format('YYYY-MM-DD');
// 		var dateEnd = picker.endDate.format('YYYY-MM-DD');
// 		var queryParamsAPI = `?fromdate=${dateStart}&todate=${dateEnd}`;
// 		var newConfigsAPI = configsAPI;
// 		newConfigsAPI.url = dateStart == dateEnd ? `${urlAPI}` : `${urlAPI}${queryParamsAPI}`;
// 		CallSJCChartAPI(valueSelect, newConfigsAPI, myChart);
// 	});
// }

// function CallSJCChartAPI(valueSelect, configsAPI, myChart){
// 	$.ajax(configsAPI).done(function (response) {
// 		var data = response.data;
// 		var provinceFullName = data[valueSelect];
// 		var labels = provinceFullName.updateTime.map(item => moment(item.date).format('DD/MM/YYYY HH:mm'));
// 		var selling = provinceFullName.updateTime.map(item => item.selling);
// 		var buying = provinceFullName.updateTime.map(item => item.buying);
// 		myChart.data = {
// 			labels: labels,
// 			datasets: [
// 				{
// 					label: `# ${langFE[checkLang].selling}`,
// 					data: selling,
// 					backgroundColor: '#008000',
// 					borderColor: '#008000',
// 				},
// 				{
// 					label: `# ${langFE[checkLang].buying}`,
// 					data: buying,
// 					backgroundColor: '#ff0000',
// 					borderColor: '#ff0000',
// 				}
// 			]
// 		};
// 		myChart.update();
// 	});
// }

// function CallSJCChartAPIRealTime(dataAPIOld, urlAPI, configsAPI, myChart){
// 	var totalUpdateOld = dataAPIOld[0].updateTime.length;
// 	var dateStart = $('#reportrange').data('daterangepicker').startDate.format('YYYY-MM-DD');
// 	var dateEnd = $('#reportrange').data('daterangepicker').endDate.format('YYYY-MM-DD');
// 	var valueSelect = $('#select-province').val();
// 	var queryParamsAPI = `?fromdate=${dateStart}&todate=${dateEnd}`;
// 	var newConfigsAPI = configsAPI;
// 	newConfigsAPI.url = dateStart == dateEnd ? `${urlAPI}` : `${urlAPI}${queryParamsAPI}`;
// 	$.ajax(newConfigsAPI).done(function (response) {
// 		var data = response.data;
// 		var totalUpdateNew = data[0].updateTime.length;
// 		if(totalUpdateOld != totalUpdateNew){
// 			var provinceFullName = data[valueSelect];
// 			var labels = provinceFullName.updateTime.map(item => moment(item.date).format('DD/MM/YYYY HH:mm'));
// 			var selling = provinceFullName.updateTime.map(item => item.selling);
// 			var buying = provinceFullName.updateTime.map(item => item.buying);
// 			myChart.data = {
// 				labels: labels,
// 				datasets: [
// 					{
// 						label: `# ${langFE[checkLang].selling}`,
// 						data: selling,
// 						backgroundColor: '#008000',
// 						borderColor: '#008000',
// 					},
// 					{
// 						label: `# ${langFE[checkLang].buying}`,
// 						data: buying,
// 						backgroundColor: '#ff0000',
// 						borderColor: '#ff0000',
// 					}
// 				]
// 			};
// 			myChart.update();
// 		}
// 	});
// }

// function CallAPIGoldPriceToday(){
// 	var checkGoldPriceByDate = $('.sjc-price-today');
// 	if(checkGoldPriceByDate.length > 0){
// 		var currentDate = moment();
// 		$('input[name="datesearch"]').val(currentDate.format('DD/MM/YYYY'));
// 		// Search date
// 		$('input[name="datesearch"]').daterangepicker({
// 			singleDatePicker: true,
// 			showDropdowns: true,
// 			autoApply: true,
// 			maxDate: currentDate,
// 			minYear: 2000,
// 			maxYear: parseInt(moment().format('YYYY'), 10),
// 			locale: {
// 				'format': 'DD/MM/YYYY',
// 				'applyLabel': `${langFE[checkLang].apply}`,
// 				'cancelLabel': `${langFE[checkLang].cancel}`,
// 			}
// 		});

// 		var dataAPI;
// 		var APIUrl = `${siteRootFE}/GoldPrice/Services/PriceService.ashx?method=GetPriceByDate`;
// 		var configs = {
// 			"url": APIUrl,
// 			"method": "POST",
// 			"timeout": 0,
// 		};
// 		$.ajax(configs).done(function (response) {
// 			dataAPI = response.data;
// 			// date = response.date;
// 			date = currentDate.format('DD/MM/YYYY');
// 			SJCTableGoldPriceToday(dataAPI, date);
// 		}).fail(function (error) {
// 			console.log(error)
// 		});

// 		// Search date
// 		$('input[name="datesearch"]').on('apply.daterangepicker', function (ev, picker) {
// 			var getDate = picker.startDate.format('DD/MM/YYYY');
// 			var queryParamsAPI = `&date=${picker.startDate.format('YYYY-MM-DD')}`;
// 			var newConfigsAPI = configs;
// 			newConfigsAPI.url = `${APIUrl}${queryParamsAPI}`;
// 			$.ajax(newConfigsAPI).done(function (response) {
// 				dataAPI = response.data;
// 				// date = response.date;
// 				date = getDate;
// 				SJCTableGoldPriceToday(dataAPI, date);
// 			});
// 		});

// 		// button search date
// 		$('.button-datesearch').on('click', function () {
// 			var getDate = moment($('input[name="datesearch"]').val()).format('DD/MM/YYYY');
// 			var queryParamsAPI = `&date=${moment(getDate).format('YYYY-MM-DD')}`;
// 			var newConfigsAPI = configs;
// 			newConfigsAPI.url = `${APIUrl}${queryParamsAPI}`;
// 			$.ajax(newConfigsAPI).done(function (response) {
// 				dataAPI = response.data;
// 				// date = response.date;
// 				date = getDate;
// 				SJCTableGoldPriceToday(dataAPI, date);
// 			});
// 		});

// 		// Cập nhật dữ liệu sau 30s
// 		setInterval(function () {
// 			var getDate = moment($('input[name="datesearch"]').val()).format('DD/MM/YYYY');
// 			var queryParamsAPI = `&date=${moment(getDate).format('YYYY-MM-DD')}`;
// 			var newConfigsAPI = configs;
// 			newConfigsAPI.url = `${APIUrl}${queryParamsAPI}`;
// 			$.ajax(configs).done(function (response) {
// 				dataAPI = response.data;
// 				// date = response.date;
// 				date = getDate;
// 				SJCTableGoldPriceToday(dataAPI, date);
// 			});
// 		}, 30000);
// 	}
// }

// function SJCTableGoldPriceToday(dataAPI, dataDate){
// 	var data = dataAPI;
// 	var table = $('.date-table tbody');
// 	$('.current-date').text(dataDate);
// 	table.empty();
// 	for (let i = 0; i < data.length; i++) {
// 		var provinceName = data[i].name; // Tên tỉnh
// 		var buy = data[i].buy; // Giá mua vào
// 		var buyDiff = data[i].buyDiff; // Giá mua vào
// 		var buyingFormat = `<span>${buy}</span><span class=${checkNumberMinus(buyDiff) ? "down" : "up"}>${checkNumberMinus(buyDiff) ? buyDiff : "+" + buyDiff}</span>`;
// 		var sell = data[i].sell; // Giá mua vào
// 		var sellDiff = data[i].sellDiff; // Giá mua vào
// 		var sellingFormat = `<span>${sell}</span><span class=${checkNumberMinus(sellDiff) ? "down" : "up"}>${checkNumberMinus(sellDiff) ? sellDiff : "+" + buyDiff}</span>`;
// 		// html
// 		var trToday = `<tr><td>${i+1}</td><td>${provinceName}</td><td>${buyingFormat}</td><td>${sellingFormat}</td></tr>`;
// 		table.append(trToday);
// 	}
// }

// function checkNumberMinus(number) {
// 	const fomatNumber = number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,').replaceAll(',', '');
// 	if (fomatNumber < 0) {
// 		return true;
// 	}
// 	return false;
// }
